// extracted by mini-css-extract-plugin
export var container = "styles-module--container--fDon7";
export var input = "styles-module--input--8NR6z";
export var text = "styles-module--text--ncLuQ";